export default __webpack_public_path__ + "static/media/xiith.79c25e77.svg";